export default __webpack_public_path__ + "static/logo-texte-628b31ac4fc341e5bc8ef069f54348b9.png";